import Basic from "../../../../content/blog/inline-css-variables/Examples/Basic";
import InlineStyle from "../../../../content/blog/inline-css-variables/Examples/InlineStyle";
import * as React from 'react';
export default {
  Basic,
  InlineStyle,
  React
};